import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import AttendeeLoginView from './pages/attendee/login/attendee-login-view';
import ProducerLoginView from './pages/producer/login/producer-login-view';
import AttendeeSliderView from './components/slider/attendee-slider/attendee-slider-view';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import NotFoundPage from './pages/error/four-zero-error';
import AudienceFeedback from './components/audienceFeedback/audienceFeedback';
import { useEffect } from 'react';

function App() {

  useEffect(() => {
    // Listen for internet disconnection and reconnection
    const handleOffline = () => {
      toast.error('Internet connection lost. Please check your connection.', {
        position: 'top-center',
      });
    };

    const handleOnline = () => {
      toast.info('Internet connection restored. Please rejoin the meeting.', {
        position: 'top-center',
      });
    };

    window.addEventListener('offline', handleOffline);
    window.addEventListener('online', handleOnline);

    // Cleanup function to remove event listeners when the component unmounts
    return () => {
      window.removeEventListener('offline', handleOffline);
      window.removeEventListener('online', handleOnline);
    };
  }, []);

  return (
    <div className="App">
      <ToastContainer />
      <BrowserRouter>
        <Routes>
          <Route path="login/attendee/:eventId" element={<AttendeeLoginView />} />
          <Route path="login/presenter/:eventId" element={<ProducerLoginView />} />
          <Route path="/attendee-dashboard" element={<AttendeeSliderView />} />
          <Route path="*" element={<NotFoundPage />} />
          <Route path="/404" element={<NotFoundPage />} />
          <Route path="/feedback/:eventId" element={<AudienceFeedback />} />

        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
